import React, { Fragment } from "react"
import { Link } from 'gatsby'

import Spinner from './spinner'
import Gallery from './gallery'

import { Container, Row, Col } from 'react-bootstrap'
import * as galleryStyles from './gallery.module.scss'


const NavigationRow = ({currentPage}) => 
    [
        "Brown",
        "Color",
        "Gold"
    ].map((page, index) => 
        <Fragment key={index}>
            { 
                index !== 0 
                    ? <span className={galleryStyles.separator}> • </span> 
                    : <></> 
            }
            {
                currentPage.includes(page) 
                    ? <span className={galleryStyles.active}>{page}</span>
                    : <Link to={`/lamps/${page.toLowerCase()}/`} className={galleryStyles.inactive}>
                            {page}
                        </Link>
            }
        </Fragment>
    )


const ProductPage = (props) => {

    const Quotes = 
        <span>
            <span className={galleryStyles.quote} style={{display: "block", textAlign: "center"}}>{ props.quotes[0] }</span> 
            <br />
            <span style={{color: "sienna", marginLeft: 10}}>Message from the artist:</span>
            <span className={galleryStyles.middleQuote}>
                { props.quotes[1] } 
            </span>
            <br />
            <span className={galleryStyles.quote}>
                { props.quotes[2] }
            </span>
        </span>



    const propertiesMatrix = Object.entries(props.properties).map( ([key, val]) => 
        <div key={key} className={galleryStyles.propertyPairContainer}>
            <div> { key } </div>
            <div> { val } </div>
        </div>
    )

    const PropertiesRow = <>
        <h2>Technical information</h2>
        <div className={galleryStyles.properties}>
            { propertiesMatrix}
        </div>
    </>


    const Description = Object.entries(props.walloftext).map( ([title, paragraphs], sectionIndex) => 
        <Fragment key={sectionIndex}>
            <h2>{ title }</h2>
            {
                paragraphs.map( (p, index) => 
                    <p 
                        key={index}
                        className={galleryStyles.wallParagraph}
                    >
                        { p }
                    </p>
                )
            }
        </Fragment>
    )
    

    return (
        <Container>
            {/* Left: image | Right: description */}
            <Row xs={1} md={2} className={galleryStyles.topRow}>
                <Col>
                    <h1 className={galleryStyles.titleMobile}>{ props.title }</h1>
                    <Spinner 
                        frames={props.spinnerSprite} 
                        sides={8}
                    />
                </Col>
                <Col className={galleryStyles.description}>
                    <h1 className={galleryStyles.title}> { props.title } </h1>
                        { Quotes }
                    <div className={galleryStyles.navigation}>
                        <NavigationRow currentPage={props.title}/>
                    </div>
                </Col>
            </Row>
            {/* Wall of text */}
            <Row>
                <Col>
                    { Description }
                    { PropertiesRow }
                </Col>
            </Row>
            {/* Gallery */}
            <Row >
                <Col>
                    <h2>Gallery</h2>
                    <Gallery items={props.galleryItems} />
                </Col>
            </Row>
            {/* Contact */}
            <Row>
                <Col className={galleryStyles.contact}>
                    <p>
                        Questions about the product? Read the 
                        <Link to="/contact/#faq"> FAQ </Link>
                        or  
                        <Link to="/contact/"> contact us</Link>
                        .
                    </p>
                </Col>
            </Row>
        </Container>
    )
}





export default ProductPage